// react
import React, { Fragment, useEffect } from "react";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import ActivitySearch from "./ActivitySearch";
// others
import { GAPageView, initGA } from "../../../../index";

// component
function ActivityList() {
    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // template
    return (
        <Fragment>
            <HeaderTitle title="Administrácia typov aktivít" />
            <section className="activities">
                <ActivitySearch />
            </section>
        </Fragment>
    );
}

export default ActivityList;
